import {
  CAT_VEHICLE_TYPE_LIST, CAT_VEHICLE_TYPE_LIST_SUCCESS, CAT_VEHICLE_TYPE_LIST_ERROR,
  CAT_VEHICLE_TYPE_PAGE_SET,
  CAT_VEHICLE_TYPE_ADD, CAT_VEHICLE_TYPE_ADD_SUCCESS, CAT_VEHICLE_TYPE_ADD_ERROR,
  CAT_VEHICLE_TYPE_ADD_CHANGE,
  CAT_VEHICLE_TYPE_DETAIL, CAT_VEHICLE_TYPE_DETAIL_SUCCESS, CAT_VEHICLE_TYPE_DETAIL_ERROR,
  CAT_VEHICLE_TYPE_UPDATE, CAT_VEHICLE_TYPE_UPDATE_SUCCESS, CAT_VEHICLE_TYPE_UPDATE_ERROR,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'id_vehicle_type', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { name: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CAT_VEHICLE_TYPE_LIST: return { ...state, loading: true };
    case CAT_VEHICLE_TYPE_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case CAT_VEHICLE_TYPE_LIST_ERROR: return { ...state, loading: false, error: true };
    case CAT_VEHICLE_TYPE_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case CAT_VEHICLE_TYPE_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case CAT_VEHICLE_TYPE_ADD: return { ...state, add: { ...state.add, loading: true } };
    case CAT_VEHICLE_TYPE_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { name: '' } } } };
    case CAT_VEHICLE_TYPE_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case CAT_VEHICLE_TYPE_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case CAT_VEHICLE_TYPE_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case CAT_VEHICLE_TYPE_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case CAT_VEHICLE_TYPE_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case CAT_VEHICLE_TYPE_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case CAT_VEHICLE_TYPE_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    default: return { ...state };
  }
};
